export default "__VITE_ASSET__5b98dd63__"